/**
 * Build the final external checkout URL for a Buy Credits / Buy Upgrades
 * button.
 *
 * Rule: the admin's URL is used **verbatim** — nothing is appended.
 *
 * The only transformation supported is placeholder substitution: if the
 * admin explicitly types `{username}`, `{user_id}`, `{email}`, `{plan}`,
 * `{credits}` or `{pack_id}` inside the URL, they'll be replaced (URL-
 * encoded) with the current buyer's values. Otherwise the URL is left
 * completely untouched.
 */
export function buildCheckoutUrl(rawUrl, user, extra = {}) {
  const url = (rawUrl || "").trim();
  if (!url) return url;

  const values = {
    username: user?.username || "",
    user_id: user?.id || "",
    email: user?.email || "",
    plan: extra.plan || "",
    credits: extra.credits != null ? String(extra.credits) : "",
    impressions: extra.impressions != null ? String(extra.impressions) : "",
    pack_id: extra.pack_id || "",
    date: extra.date || "",
    website_id: extra.website_id || "",
  };

  return url.replace(/\{(username|user_id|email|plan|credits|impressions|pack_id|date|website_id)\}/gi, (_, key) => {
    const k = key.toLowerCase();
    return encodeURIComponent(values[k] || "");
  });
}
